import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Center } from '../interfaces/center';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, throwError } from 'rxjs';

export interface BackfillResult {
  processed: number;
  skipped: number;
  errors: number;
}

@Injectable({
  providedIn: 'root'
})
export class CenterService {
  private apiUrl = environment.apiUrl + 'centers';
  private adminUrl = environment.apiUrl + 'admin';

  constructor(private http: HttpClient) {}

  getAllCenters(): Observable<Center[]> {
    return this.http.get<Center[]>(this.apiUrl).pipe(
      catchError((error) => {
        console.error('Error fetching centers:', error);
        return throwError(() => new Error('Failed to fetch centers'));
      })
    );
  }

  updateCenter(center: Center): Observable<Center> {
    return this.http.put<Center>(`${this.apiUrl}/${center.id}`, center).pipe(
      catchError((error) => {
        console.error('Error updating center:', error);
        return throwError(() => new Error('Failed to update center'));
      })
    );
  }

  getCenterById(id: string): Observable<Center> {
    return this.http.get<Center>(`${this.apiUrl}/${id}`).pipe(
      catchError((error) => {
        console.error('Error fetching center:', error);
        return throwError(() => new Error('Failed to fetch center'));
      })
    );
  }

  backfillParticipantSnapshots(): Observable<BackfillResult> {
    return this.http.post<BackfillResult>(`${this.adminUrl}/backfill-participant-snapshots`, {}).pipe(
      catchError((error) => {
        console.error('Error backfilling participant snapshots:', error);
        return throwError(() => new Error('Failed to backfill participant snapshots'));
      })
    );
  }
}
